import { useEffect } from "react";
import { useSettings } from "@/hooks/useSettings";

/**
 * Component to dynamically apply site colors from settings
 */
export const DynamicColors = () => {
  const { settings, isLoading } = useSettings();

  useEffect(() => {
    if (isLoading || !settings) return;

    // Apply colors to CSS variables
    const root = document.documentElement;

    if (settings.color_primary) {
      root.style.setProperty("--primary", settings.color_primary);
    }

    if (settings.color_secondary) {
      root.style.setProperty("--secondary", settings.color_secondary);
    }

    if (settings.color_accent) {
      root.style.setProperty("--accent", settings.color_accent);
    }
  }, [settings, isLoading]);

  return null;
};

export default DynamicColors;
